import { render } from "./NSlider.vue?vue&type=template&id=bb641742&ts=true"
import script from "./NSlider.vue?vue&type=script&lang=ts"
export * from "./NSlider.vue?vue&type=script&lang=ts"

import "./NSlider.vue?vue&type=style&index=0&id=bb641742&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__